<template>
  <div v-if="show" class="policy-modal-overlay">
    <div class="policy-modal-card">
      <button class="modal-close-btn" @click="closeModal" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#1D2941"/>
          <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="policy-modal-content">
        <h2 class="policy-title">{{ type === 'privacy' ? 'Privacy Policy' : (type === 'terms' ? 'Terms of Service' : 'Refund Policy') }}</h2>
        
        <div v-if="type === 'privacy'">
          <p class="policy-body">
          Makeping (hereinafter also referred to as “we”) is committed to protecting the privacy of its website visitors. Please read the following policy to understand how we collect and use your personal data as well as your rights relating to the processing of your personal data by Makeping. Note that we reserve the right to amend and update this policy from time to time, so please check this page periodically.
        </p>

        <h3 class="policy-heading">1. What personal data do we collect?</h3>
        <p class="policy-body">
          You are not required to provide us with your personal data to access any area of this website. However, when you request to contact us, subscribe to our newsletters, or access specific resources, we may collect your data to respond to your request.
        </p>

        <h3 class="policy-heading">2. How we use your personal data and for which purposes</h3>
        <p class="policy-body">We will use your data for the following purposes:</p>
        <ul class="policy-list">
          <li>If you contact us, we will collect your name, email, and message. We will use your data only to respond to your inquiry.</li>
          <li>If you subscribe to our newsletters, we will collect your email address. We will use your data only to send you newsletters and updates about Makeping.</li>
          <li>If you access specific resources, such as e-books or whitepapers, we may collect your name, email, and company name. We will use your data only to provide you with the requested resource and to send you future updates about Makeping.</li>
        </ul>

        <h3 class="policy-heading">3. Cookies</h3>
        <p class="policy-body">
          We use cookies on this website. For more information, please see our <a href="#" class="policy-link">cookie policy</a>.
        </p>

        <h3 class="policy-heading">4. Security</h3>
        <p class="policy-body">
          The security of your personal data is of utmost importance to us. We are committed to maintaining the highest technical and organizational measures to protect the integrity, confidentiality, and availability of personal data and to keep such secure against unauthorized access, misuse, disclosure, unlawful destruction, or loss.
        </p>

        <h3 class="policy-heading">5. Who has access to your personal data?</h3>
        <p class="policy-body">
          We will not share or disclose your personal data to any third party except (if needed) from our trusted service providers, including IT entities and advertising agencies who act on behalf and under the instructions of Makeping and are bound to comply with all necessary technical and organizational measures for the protection of your personal data.
        </p>

        <h3 class="policy-heading">6. How long do we retain your personal data?</h3>
        <p class="policy-body">
          We will keep your personal data only for as long as it is necessary for the purposes of the processing mentioned above.
        </p>

        <h3 class="policy-heading">7. Your rights</h3>
        <p class="policy-body">You have the right to:</p>
        <ul class="policy-list">
          <li>Request a copy of the data we hold about you</li>
          <li>Have your data erased or rectified</li>
          <li>Restrict and object to the processing of your personal data</li>
          <li>Withdraw your consent from receiving marketing materials from us</li>
          <li>Receive the personal data that we keep about you in a structured, commonly used, and machine-readable format and to have them transmitted to another company suggested by you</li>
        </ul>
        <p class="policy-body">
          To exercise any of these rights, please send an email to <a href="mailto:support@makeping.com" class="policy-link">support@makeping.com</a>
        </p>

        <h3 class="policy-heading">8. Contact details</h3>
          <p class="policy-body">
            If you have any questions or concerns about this policy or wish to exercise any of your rights, please send us an email at <a href="mailto:support@makeping.com" class="policy-link">support@makeping.com</a>.
          </p>
        </div>

        <div v-if="type === 'terms'">
          <h3 class="policy-heading" style="margin-top: 0;">Acceptance of Terms</h3>
          <p class="policy-body">
            Welcome to Makeping(“Makeping”, “us”, “our”, or “we”). By visiting the Website, you agree to these Terms and Conditions (“T&Cs”) and the makeping.com Privacy Policy. If you do not agree to these T&Cs, please do not visit the Website.
          </p>

          <h3 class="policy-heading">Intellectual Property</h3>
          <p class="policy-body">
            All content on the Website, including text, images, and videos, is the property of makeping.com or its licensors. You may not remove, modify, distribute, reuse, or repost any content without our express written permission.
          </p>

          <h3 class="policy-heading">Use of the Website</h3>
          <p class="policy-body">
            You may not use the Website for any unlawful or prohibited purpose. You may not attempt to gain unauthorized access to the Website, our servers, or our networks. You may not use the Website in any manner that could damage, disable, or impair our servers or networks.
          </p>

          <h3 class="policy-heading">Disclaimers</h3>
          <p class="policy-body">
            Your use of the Website is at your sole risk. We make no express or implied warranties, conditions, or representations with respect to the Website or its content. The Website and all content are provided on an “as is,” “as available” basis, without representations or warranties of any kind.
          </p>

          <h3 class="policy-heading">Limitation of Liability</h3>
          <p class="policy-body">
            We are not responsible for any errors or omissions in the content or for damages arising from the use or performance of the Website. In no event will we be liable to anyone for any direct, indirect, punitive, special, exemplary, incidental, consequential, or other damages of any type or kind.
          </p>

          <h3 class="policy-heading">Third-Party Links and Services</h3>
          <p class="policy-body">
            The Website may provide links to third-party websites or resources. We are not responsible for such content or the availability of such external websites or resources. Your interactions with such third parties will be governed by their own terms of service and privacy policies.
          </p>

          <h3 class="policy-heading">Waiver, Severability, and Entire Agreement</h3>
          <p class="policy-body">
            Our failure to require performance of any provision of these T&Cs or to exercise any right provided for herein will not be deemed a waiver of such provision or such right. These T&Cs comprise the entire agreement between you and makeping.com with regard to the Website.
          </p>

          <h3 class="policy-heading">Modification</h3>
          <p class="policy-body">
            We reserve the right to update or modify the Website or these T&Cs at any time without prior notice. Your use of the Website following any such change constitutes your agreement to be bound by the modified T&Cs.
          </p>

          <h3 class="policy-heading">Governing Law</h3>
          <p class="policy-body">
            These T&Cs shall be construed in accordance with the applicable laws of UAE. The Courts at Dubai shall have exclusive jurisdiction in any proceedings arising out of these T&Cs.
          </p>

          <h3 class="policy-heading">Acknowledgment</h3>
          <p class="policy-body">
            By accessing the Website, you acknowledge that you have read these T&Cs and agree to be bound by them.
          </p>

          <h3 class="policy-heading">Contact</h3>
          <p class="policy-body">
            If you have questions about our website or these T&Cs, please contact us at: <a href="mailto:support@makeping.com" class="policy-link">support@makeping.com</a>
          </p>
        </div>

        <div v-if="type === 'refund'">
          <h3 class="policy-heading" style="margin-top: 0;">General Terms</h3>
          <p class="policy-body">
            Optional paid services such as extra monitors, extra seats, shorter monitor intervals, or extra SMS message / voice call credits are available on the products (any such service is considered an “Upgrade”). By selecting an Upgrade you agree to pay Makeping the monthly or annual subscription fees indicated for that service. Payments will be charged on a pre-paid basis on the day you sign up for an Upgrade and will cover the use of that service for a monthly or annual subscription period as indicated. In the case of standalone SMS message / voice call credit packages, there is a one-time pre-paid payment with the possibility of auto-refill to trigger when your credit balance gets low. For any plan upgrade, the payment method that you provided will be charged or credited the new prorated amount for the current payment period upon your request. You will be requested to pay the rate for the upgrade for the period from the date of the upgrade to the end of your current billing cycle. After successful confirmation of purchase, you will receive access to your new plan within a few minutes (depending on the speed of our payment processor). The new rate will apply to your next billing cycle. A downgrade in a plan will be scheduled for your usual renewal date, meaning your current plan will remain active until the end of your currently prepaid period. The new rate for your plan will apply and be charged on your next billing cycle. As an exception, if you downgrade your plan within 24 hours of expiration, the new plan will become active within a few minutes, without any proration applied. If the new plan does not fit the limits of your account resources (e.g., monitors and/or seats, etc.) we reserve the right to deny a downgrade of your plan, or to suspend resources that do not fit the limit. In such cases you will be informed before this happens. Makeping reserves the right to change the payment terms and fees.
          </p>

          <h3 class="policy-heading">Automatic Renewal</h3>
          <p class="policy-body">
            Unless you notify Makeping before the end of the applicable subscription period that you want to cancel an Upgrade, your Upgrade subscription will automatically renew and you authorize us to collect the then-applicable annual or monthly subscription fee for such Upgrade (as well as any taxes) using any credit card or other payment mechanism we have on record for you. Upgrades can be canceled at any time in the My Settings section of your site's dashboard.
          </p>

          <h3 class="policy-heading">Refunds and Cancellation</h3>
          <p class="policy-body">
            You have the right to withdraw from the Agreement (including any Upgrade) without giving any reason within fourteen (14) calendar days after entering into the Agreement or Upgrade (the “Withdrawal Period”). The right of withdrawal shall not apply if you have commenced the use of paid Services or Upgrades with your explicit consent before the expiry of the Withdrawal Period. Upon withdrawal, Makeping shall reimburse all payments received from you, without undue delay and no later than fourteen (14) calendar days from the day on which we are informed of the withdrawal.
          </p>
          <p class="policy-body">
            You may terminate your subscription to an Upgrade at any time, in which case you will not be charged for any future subscription renewal periods (though your current prepaid period will continue until its end). However, any subscription fees you have paid in advance will not be refunded outside of the Withdrawal Period. For special cases or material breaches by Makeping, refunds or service credits for paid but unused Services may be granted at our sole discretion.
          </p>

          <h3 class="policy-heading">Governing Law</h3>
          <p class="policy-body">
            This Refund Policy shall be construed in accordance with the applicable laws of UAE. The Courts at Dubai shall have exclusive jurisdiction in any proceedings arising out of this Policy.
          </p>

          <h3 class="policy-heading">Contact</h3>
          <p class="policy-body">
            If you have questions about our services or this Refund Policy, please contact us at: <a href="mailto:support@makeping.com" class="policy-link">support@makeping.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyModal',
  props: {
    show: { type: Boolean, default: false },
    type: { type: String, default: 'privacy' }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;1,500&family=Roboto:wght@400;500&display=swap');

.policy-modal-overlay {
  position: fixed;
  z-index: 2000;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(30, 34, 54, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.policy-modal-card {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 650px;
  max-height: 90vh;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 24px;
  border: 1px solid rgba(248, 65, 9, 0.20);
  background: linear-gradient(180deg, rgba(255, 255, 255, 1.0) 40%, rgba(254, 230, 222, 1.0) 100%);
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
}

.modal-close-btn {
  position: absolute;
  top: 25px;
  right: 25px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  z-index: 10;
}

.modal-close-btn:hover {
  opacity: 0.8;
}

.policy-modal-content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-right: 15px; /* space for scrollbar */
}

/* Custom Scrollbar for the content area */
.policy-modal-content::-webkit-scrollbar {
  width: 6px;
}
.policy-modal-content::-webkit-scrollbar-track {
  background: transparent;
}
.policy-modal-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.policy-title {
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-style: italic;
  font-weight: 500;
  line-height: 28px;
  margin-top: 0;
  margin-bottom: 24px;
}

.policy-body {
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 24px;
}

.policy-list {
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 24px;
  padding-left: 20px;
}

.policy-list li {
  margin-bottom: 8px;
  position: relative;
}

.policy-list li::marker {
  content: "• ";
}

.policy-heading {
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Roboto', sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  margin-top: 32px;
  margin-bottom: 12px;
}

.policy-link {
  color: #F84109;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: opacity 0.2s;
}

.policy-link:hover {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .policy-modal-card {
    height: 90vh;
    padding: 20px;
  }
}
</style>
